import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { usePricingTabContext } from "../../hooks/usePricingTabContext";
import { PricingTabAddPriceModalNoticeBox } from "./NoticeBox";
import { noticeScenarios } from "./NoticeScenarios";

export const PriceDescriptionBox = () => {
  const { currency, priceBuildOptions } = usePricingTabContext();

  const { watch } = useFormContext();

  const hasTrialPeriod = Boolean(watch("enable_trial"));
  const trialType = watch("trial_type");
  const trialDays =
    priceBuildOptions.subscription.trial_options[trialType]?.trial_days ?? 0;

  const priceType = watch("price_type");
  const buildOptions = priceBuildOptions[priceType];

  const hasUpfrontPayment = Boolean(watch("upfront_payment_enabled"));
  const isUpfrontPaymentRequiredForTrial = Boolean(
    watch("trial_requires_upfront_payment"),
  );

  const scenario = noticeScenarios.find(({ matcher }) =>
    matcher({
      priceType,
      hasUpfrontPayment,
      hasTrialPeriod,
      isUpfrontPaymentRequiredForTrial,
    }),
  );
  if (!scenario) {
    return null;
  }

  const validateState = scenario.stateValidator;
  if (!validateState({ watch })) {
    return null;
  }

  const resolveMessageProps = scenario.messagePropsResolver;
  const [messageKey, messageProps] = resolveMessageProps({
    buildOptions,
    currency,
    trialPeriodDays: trialDays,
    watch,
  });

  return (
    <PricingTabAddPriceModalNoticeBox>
      {t(
        [
          "settings.paywalls.modal.tabs.pricing.add_price_modal.notice",
          messageKey,
        ],
        messageProps,
      )}
    </PricingTabAddPriceModalNoticeBox>
  );
};
